import React, { FC } from 'react';
import { IoRocketOutline } from 'react-icons/io5';

import { MenuDropdownLink } from 'components/header/components/Menu';
import { usePageLoadGlobals } from 'hooks/use-page-load-globals';
import { useWorkspaceConfig } from 'hooks/use-workspace-config';

// const UPDATE_MESSAGE_HASH_KEY = 'update_message_hash';

const UpdateMessage: FC = () => {
    const updateMessage = usePageLoadGlobals()?.updateMessage;
    const { workspace: workspaceActive } = useWorkspaceConfig();

    // const [showMessage, setShowMessage] = useState(false);
    // const storedHash = LocalStorageService.get(UPDATE_MESSAGE_HASH_KEY);

    // const messageAsString = `${updateMessage?.title ?? ''}${updateMessage?.description ?? ''}${updateMessage?.label ?? ''}${updateMessage?.url ?? ''}`;

    // useEffect(() => {
    //     if (messageAsString.length) {
    //         digestString(messageAsString).then((hash) => {
    //             if (hash !== storedHash) {
    //                 setShowMessage(true);
    //             } else {
    //                 setShowMessage(false);
    //             }
    //         });
    //     }
    // }, [messageAsString, storedHash]);

    // const setMessageHidden = () => {
    //     setShowMessage(false);

    //     digestString(messageAsString).then((hash) => {
    //         LocalStorageService.store(UPDATE_MESSAGE_HASH_KEY, hash);
    //     });
    // };

    // if (!showMessage) return null;

    if (workspaceActive) {
        return null;
    }

    if (!updateMessage?.title || !updateMessage?.description || !updateMessage?.url) {
        return null;
    }

    return (
        <MenuDropdownLink
            item={{
                icon: <IoRocketOutline />,
                title: updateMessage.title,
                description: updateMessage.description,
                href: updateMessage.url,
                external: true,
            }}
        />
    );
};

export { UpdateMessage };
